import anime from 'animejs';

let preloader = document.getElementById("preloader");

export const initPreloader = anime({
	easing: 'easeInOutQuart',
	duration: 650,
	targets: preloader,
	autoplay: true,
	
	opacity: 0,

	complete: function() {
		preloader.style.display = "none";
	},
});	